import { Typography, Stack } from "@mui/material";

const JumpToSection = ()=> {
    const scrollToElement = (id: string)=>{
        const element = document.getElementById(id)
        if(element) {
            element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        }
    }

    const jumpToArray =[
        {class: 'about', title:'About'},
        {class: 'projects', title:'Projects'},
        {class: 'career', title:'Career'},
        {class: 'education', title:'Education & Qualifications'},
        {class: 'known_tech', title:'Known Technologies'},
    ]

    return (
        <Stack 
            direction={'column'} 
            sx={{
                color:'#420A02', 
                padding:'2rem', 
                marginTop:'2rem', 
                marginLeft:'2rem', 
                float:"left",
                textWrap:"nowrap",
                textAlign:"left"
                }}>
            <Typography variant="h4" sx={{paddingBottom:'0.5rem'}}>Jump To:</Typography>
            
            {jumpToArray.map((jumpTo, i )=>
            <Typography variant="h5" onClick={()=>scrollToElement(jumpTo.class)} sx={{":hover":{cursor:'pointer',textDecoration:'underline'}}}>{jumpTo.title}</Typography>)}
        </Stack>
    
    );
}
  
  export default JumpToSection;